/** Shared flat-illustration palette: wine, terracotta, saffron, sage, cream. */
export const ART = {
  wine: '#7c2942',
  wineDeep: '#5d1f33',
  clay: '#b0532e',
  claySoft: '#f2ddd3',
  saffron: '#d9a441',
  saffronSoft: '#f7ecd4',
  sage: '#7a9b76',
  sageSoft: '#e3ebdf',
  plum: '#6b4a7a',
  plumSoft: '#ece3f1',
  cream: '#faf6f0',
  skin1: '#8d5a3a',
  skin2: '#6f4529',
  skin3: '#a06844',
} as const;
